import React from 'react'
import { useViewportSize } from '@mantine/hooks'
import { Box, Center, Loader } from '@mantine/core'

const LoadingSection = () => {
  const { width, height } = useViewportSize()
  return (
    <Box pos="relative">
      <Center maw={width} h={height / 2} mx="auto">
        <Loader size="md" />
      </Center>
    </Box>
  )
}

export default LoadingSection